import {isEmpty} from "@/utils/fileHelper";
import { hasRule, rules as adminRules, espaceGestionRules as rulesDC } from "@/utils/rulesHelper"

export function formatDateTime(textDate, separateur) {
	let date_action = new Date(textDate);
  if (isEmpty(separateur)) {
    separateur = '/';
  }
  return ("00" + date_action.getDate()).slice(-2)
    	+ separateur
      	+ ("00" + (date_action.getMonth() + 1)).slice(-2)
      	+ separateur + date_action.getFullYear()
      	+ " à "
      	+ ("00" + (date_action.getHours())).slice(-2)
      	+ ":" + ("00" + (date_action.getMinutes())).slice(-2);
}

export function formatDate(textDate) {
  return  textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
}

export function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
}

export function replaceDotToComma(num) {
  return !isEmpty(num) ? num.toString().replace(/\./g, ',') : '';
}
export function replaceCommaToDot(num) {
  return !isEmpty(num) ? num.toString().replace(/\,/g, '.') : '';
}
export function getMainTreatmentBasedOnType(dossier, allTraitements) {
  let traitement = '';
  if (!isEmpty(dossier.traitement_id)) {
    traitement = allTraitements.reduce((res, traitement) => {
      return parseInt(traitement.id,10) === parseInt(dossier.traitement_id,10) ? traitement : res;
    },{});
  } else {
    let traitementGestionIj = allTraitements.reduce((res, traitement) => {
      return traitement.libelle_technique === 'ij_gestion_prestation' ? traitement : res;
    },{});
    let traitementGestionInval = allTraitements.reduce((res, traitement) => {
      return traitement.libelle_technique === 'gestion_inval' ? traitement : res;
    },{});
    let traitementGestionDc = allTraitements.reduce((res, traitement) => {
      return traitement.libelle_technique === 'gestion_dc' ? traitement : res;
    },{});
    let traitementGestionDb = allTraitements.reduce((res, traitement) => {
      return traitement.libelle_technique === 'gestion_dbco' ? traitement : res;
    },{});
    let traitementPfe = allTraitements.find(traitement => traitement.libelle_technique === 'qualification_courrier')

    if (dossier.type && dossier.type.groupe.toLowerCase() === 'ij') {
      traitement = traitementGestionIj;
    } else if (dossier.type && dossier.type.groupe.toLowerCase() === 'inval') {
      traitement = traitementGestionInval;
    } else if (dossier.type && dossier.type.groupe.toLowerCase() === 'dc') {
      traitement = traitementGestionDc;
    } else if (dossier.type && dossier.type.groupe.toLowerCase() === 'dbco') {
      traitement = traitementGestionDb;
    } else if (isEmpty(dossier.type)) {
      // Si pas de type on est dans le cas du PFE, seul traitement à avoir des dossier sans type
      traitement = traitementPfe;
    }
    // On verifie que le traitement trouvé à bien un statut, sinon on est dans le cas d'un traitement principal parrallèle (ex Fichier prolongation)
    if (dossier.status && !treatmentHasStatus(dossier.status, traitement.id)) {
      let traitementModulePrevoyance = allTraitements.reduce((res, traitement) => {
        return traitement.libelle_technique === 'ij_module_prevoyance' ? traitement : res;
      },{});
      if (treatmentHasStatus(dossier.status, traitementModulePrevoyance.id)) {
        traitement = traitementModulePrevoyance;
      }
    }
  }

  return traitement;
}

function treatmentHasStatus(dossierStatus, treatmentId) {
  let find = false;
  // console.log(dossierStatus)
  for (let status of dossierStatus) {
    if (parseInt(status.pivot.traitement_id,10) === parseInt(treatmentId,10)) {
      find = true;
    }
  }
  return find;
}

export function dossierHasAffectation(dossier, traitementId) {
  let hasAffectation = false;

  for (let gestionnaire of dossier.gestionnaires) {
    if (parseInt(traitementId,10) === parseInt(gestionnaire.pivot.traitement_id)) {
      hasAffectation = true;
      break;
    }
  }
  return hasAffectation;
}

export function getIconPostit(type, dossier) {
  let images = require.context('@/assets/images/', false, /\.png$/)
  let icon = ''

  if (type === 'corner') {
    icon = 'corner-top-right-10.png'
  }

  if (type === 'post-it') {
    if (dossier.commentaires_gestion.length === 0) {
      icon = 'post-it-no-note-26.png'
    } else {
      let is_rc = dossier.commentaires_gestion[0].is_relation_client
      let urgent = dossier.commentaires_gestion.reduce((res, item) => {
        return res || item.is_urgent
      }, false)


      if(dossier.commentaires_gestion[0].gestionnaire != null && dossier.commentaires_gestion[0].gestionnaire.nom != 'Système') {
        if(is_rc && urgent){
          icon = 'post-it-ext-urgent-26.png';
        }else if(is_rc){
          icon = 'post-it-ext-26.png';
        }else{
          icon = urgent ? 'post-it-urgent-26.png' : 'post-it-normal-26.png';
        }
      } else {
        icon = urgent ? 'post-it-urgent-vert-26.png' : 'post-it-vert-26.png';
      }
    }
  }

  return images('./' + icon)
}

export function canSeeCritere(type) {
  let can = false;
  if (type === 'flag') {
    can = hasRule(adminRules.IS_ADMIN)
  }
  return can;
}

export function formatSiret(siret) {
  if (siret.length <= 9) {
    return siret;
  } else if (siret.length >= 14) {
    return siret.substring(0,9) + ' ' + siret.substring(9);
  } else {
    return siret.substring(0,9) + ' ' + siret.substring(9).padStart(5, '0');
  }
  return siret;
}

export function dossierHasOpenIncident(dossier, statusTraiteIds) {
  let hasOpenIncident = false;
  statusTraiteIds.push(0); // On ajoute le "traité" des DPC

  for (let incident of dossier.incidents) {
    if (statusTraiteIds.indexOf(incident.status_id) === -1 ) {
      hasOpenIncident = true;
      break;
    }
  }
  return hasOpenIncident;
}

// HMESS-318
export function cantEditFicheDC(dossier) {
    return (
        hasRule(rulesDC.CANT_EDIT_FICHE_DC) &&
        dossier &&
        dossier.type &&
        dossier.type.groupe &&
        typeof dossier.type.groupe === 'string' &&
        dossier.type.groupe.toLowerCase() === 'dc');
}
